import * as React from "react";
import { Pagination } from "react-bootstrap";
import { PaginationItem, ActionHandlerFunction } from "@preveil-api";
import { UIManagerActionTypes, GlobalConstants } from "src/common";
import { Icon } from "src/components";

interface AllProps {
    pagination: PaginationItem;
    className?: string;
    handleAction: ActionHandlerFunction;
}

function PaginationComponent(props: AllProps) {
    const { pagination, className, handleAction } = props;
    const number_pager_links: number = GlobalConstants.PAGINATION_LINKS_MAX;

    function renderPaginationLinks() {
        const page_number = (pagination.pageIndex + 1);
        let range_index = Math.ceil(page_number / number_pager_links); // This is the number interval of pager links
        range_index = range_index <= 0 ? 1 : range_index;
        const max = (number_pager_links * range_index) >= pagination.pageCount ? pagination.pageCount : (number_pager_links * range_index);
        let min = max - number_pager_links + 1;
        (min <= 0) && (min = 1);
        const links = [];
        for (let i = min; i <= max; i++) {
            links.push(
                (page_number === i) ?
                    <Pagination.Item className="hide-desktop-lg" key={`page_number_${i}`} active >{i}</Pagination.Item> :
                    <Pagination.Item className="hide-desktop-lg"
                        onClick={() => handleAction({ actionType: UIManagerActionTypes.Paging, params: i })} key={`page_number_${i}`} >{i}</Pagination.Item>
            );
        }
        return links;
    }

    return (!!pagination && pagination.pageCount > 1) ?
        <Pagination
            size="sm"
            className={`mb-0 justify-content-end ${className}`}
            aria-label={"Pagination"} >
            <Pagination.First className="hide-mobile-sm"
                onClick={() => handleAction({ actionType: UIManagerActionTypes.Paging, params: 1 })}
                disabled={pagination.pageIndex === 0} >
                <Icon className="ficon-chevrons-left" />
            </Pagination.First>
            <Pagination.Prev
                onClick={() => handleAction({ actionType: UIManagerActionTypes.Paging, params: (pagination.pageCount > 1 ? (pagination.pageIndex) : 1) })}
                disabled={pagination.pageIndex === 0} >
                <Icon className="ficon-chevron-left" />
            </Pagination.Prev>
            {
                renderPaginationLinks()
            }
            <Pagination.Next
                onClick={() => handleAction({ actionType: UIManagerActionTypes.Paging, params: (pagination.pageIndex < pagination.pageCount ? (pagination.pageIndex + 2) : pagination.pageCount) })}
                disabled={(pagination.pageIndex + 1) === pagination.pageCount}>
                <Icon className="ficon-chevron-right" />
            </Pagination.Next>
            <Pagination.Last className="hide-mobile-sm"
                onClick={() => handleAction({ actionType: UIManagerActionTypes.Paging, params: pagination.pageCount })}
                disabled={(pagination.pageIndex + 1) === pagination.pageCount} >
                <Icon className="ficon-chevrons-right" />
            </Pagination.Last>
        </Pagination> : <></>;
}

export default React.memo(PaginationComponent);
